<template>
  <f7-panel
    v-if="showLeftPanel"
    left
    cover
    resizable
    class="panel panel-left not-animated content-menu"
    :opened="showToDefault"
    :visible-breakpoint="1024"
    :collapsed-breakpoint="1023"
  >
    <f7-page>
      <div class="content-menu-header">
        <div
          class="menu-header-item"
          @click="goToHomePage"
        >
          <img
            v-if="selection === 'GreenHouse'"
            class="image_logo"
            :src="VEG_SYST"
          >
          <img
            v-else
            class="image_logo"
            :src="OPEN_AIR"
          >
        </div>
      </div>
      <f7-list
        accordion-list
        class="content-list-menu"
      >
        <ul>
          <li
            v-for="(item, index) in elements"
            v-if="item.name === 'LeftPanel_title_result'
              ? resultProject
                ? selection === 'GreenHouse'
                  ? resultProject.type==='GH'
                  : resultProject.type==='EX'
                : false
              : item.url === '/recommendationsResult/'
                ? showRecommendations
                : true"
            :key="index"
            :class="{
              'accordion-item': item.menus && item.menus.length,
              'accordion-item-opened': (item.name === 'LeftPanel_title_result' && clickOpenResults)
            }"
            @click="
              item.name === 'LeftPanel_title_result'
              ? clickOpenResults ? closeResults() : openResults()
              : null
            "
          >
            <template
              v-if="isGranted(item) && ($t(item.name) !== ''
                && $t(item.name) !== 'INFORMATION')"
            >
              <a
                :class="`item-content item-link ${item.menus && item.menus.length ? '' : 'panel-close close'}`"
                @click="navigateTo(item.url, item.menus && item.menus.length)"
              >
                <div class="item-inner">
                  <f7-icon
                    v-if="(typeof item.icon !== `undefined`)"
                    slot="media"
                    :class="`icon-menu ${item.icon}`"
                    width="32"
                    height="32"
                  />
                  <div class="item-title">{{ $t(item.name) }}</div>
                </div>
              </a>
              <f7-accordion-content>
                <f7-list>
                  <f7-list-item
                    v-for="(itemMenu, index2) in item.menus"
                    v-if="
                      isGranted(itemMenu)
                        && !(resultProject
                          && resultProject.weather_source_type === 'MEAN_YEAR'
                          && itemMenu.url === '/recommendationsResult/')
                    "
                    :key="index2"
                    class="panel-close close"
                    :class="{highlight:getActualMenuSelected == itemMenu.url}"
                    accordion-list
                    :link=" itemMenu.url ? '#' : null"
                    @click="itemMenu.url ? navigateTo(itemMenu.url) : null"
                  >
                    <f7-icon
                      v-if="(typeof itemMenu.icon !== `undefined`)"
                      :class="`icon-menu ${itemMenu.icon} margin-left-icon`"
                      :link="itemMenu.url"
                      width="32"
                      height="32"
                    />
                    <a v-if="(typeof(itemMenu.icon)!=='undefined')">
                      {{ $t(itemMenu.name) }}
                    </a>
                    <a v-else>
                      {{ $t(itemMenu.name) }}
                    </a>
                  </f7-list-item>
                </f7-list>
              </f7-accordion-content>
            </template>
            <template
              v-else-if="$t(item.name) === '' && getActualMenuSelected === undefined"
            >
              <f7-list-item
                v-for="(itemMenu, index2) in item.menus"
                :key="index2"
                class="panel-close close highlight"
                :class="{highlight:getActualMenuSelected == itemMenu.url}"
                accordion-list
                @click="navigateTo(itemMenu.url)"
              >
                <f7-icon
                  v-if="(typeof(itemMenu.icon)!=='undefined')"
                  slot="media"
                  :class="`icon-menu ${itemMenu.icon}`"
                  :link="itemMenu.url"
                  width="32"
                  height="32"
                />
                <a v-if="(typeof(itemMenu.icon)!=='undefined')">
                  {{ $t(itemMenu.name) }}
                </a>
                <a v-else>
                  {{ $t(itemMenu.name) }}
                </a>
                <br>
              </f7-list-item>
            </template>
            <template
              v-else
            >
              <f7-list-item
                v-for="(itemMenu, index2) in item.menus"
                :key="index2"
                class="panel-close close"
                :class="{highlight:getActualMenuSelected == itemMenu.url}"
                accordion-list
                @click="navigateTo(itemMenu.url)"
              >
                <f7-icon
                  v-if="(typeof(itemMenu.icon)!=='undefined')"
                  slot="media"
                  :class="`icon-menu ${itemMenu.icon}`"
                  :link="itemMenu.url"
                  width="32"
                  height="32"
                />
                <a>
                  {{ $t(itemMenu.name) }}
                </a>
                <br>
              </f7-list-item>
            </template>
          </li>
        </ul>
      </f7-list>
    </f7-page>
  </f7-panel>
</template>

<script>
import {
  mapState, mapActions, mapGetters,
} from 'vuex';
import moment from 'moment';
import {
  APPLICATION_NAME, APP_LOGO, VEG_SYST, OPEN_AIR,
} from '../js/constants';
import store from '../store/index';
import EventBus from '../js/event-bus';

export default {
  name: 'LeftPanel',
  store,
  props: {
    elements: { type: Array, default: () => [] },
    showToDefault: { type: Boolean, default: true },
    version: { type: String, default: '1.0.0' },
  },
  data() {
    return {
      APPLICATION_NAME,
      APP_LOGO,
      VEG_SYST,
      OPEN_AIR,
      alwaysOpen: 0,
      clickOpenResults: true,
    };
  },
  computed: {
    appName() {
      return this.APPLICATION_NAME;
    },
    appLogo() {
      return localStorage.getItem('applogo') || this.APP_LOGO;
    },
    showRecommendations() {
      if (
        this.resultProject
          && this.resultProject.type === 'EX'
          && this.resultProject.weather_source_type !== 'MEAN_YEAR'
      ) {
        const cultiveDateInit = moment(this.resultProject.cultive.date_init).toDate();
        const cultiveDateEnd = moment(this.resultProject.cultive.date_end).toDate();
        const now = new Date(Date.now());
        if (cultiveDateInit < now && cultiveDateEnd > now) {
          return true;
        }
      }
      return false;
    },
    ...mapState('authentication', ['user', 'showLeftPanel', 'selection']),
    ...mapState('Result', ['resultProject']),
    ...mapGetters('authentication', ['getActualMenuSelected', 'getPermissions']),
  },
  beforeMount() {
    EventBus.$on('openResultsAccordion', this.openResults);
  },
  methods: {
    navigateTo(path) {
      if (path === '/accounts/loginPage/') {
        // store.dispatch('authentication/logout');
        this.logoutPressed();
      } else if (path === '/pageRegisterProject/') {
        this.resetNewProject();
        this.resetNewProjectOpenAir();
        this.setActualMenuSelected(path);
        this.$f7.views.main.router.navigate(path, { reloadCurrent: true });
      } else {
        this.setActualMenuSelected(path);
        this.$f7.views.main.router.navigate(path, { reloadCurrent: true });
      }
    },
    logoutPressed() {
      this.setShowLeftPanel(false);
      const self = this;
      self.$f7.panel.close('left', false);
      self.logout();
    },
    isGranted(menu) {
      if (menu.permission === 'ALL') return true;
      return (this.$helpers.havePermission(this.getPermissions[`${menu.permission}`]));
    },
    goToHomePage() {
      this.$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true });
    },
    closeResults() {
      this.clickOpenResults = false;
    },
    openResults() {
      this.clickOpenResults = true;
    },
    ...mapActions('authentication', ['logout', 'setActualMenuSelected', 'setShowLeftPanel']),
    ...mapActions('ProjectGreenHouse', ['resetNewProject']),
    ...mapActions('ProjectOpenAir', ['resetNewProjectOpenAir']),
  },
};
</script>

<style lang="scss">
.home{
  content: url("../static/icons/Inicio.svg");
  max-height: 18px;
}
.newProject{
  content: url("../static/icons/iconNewProject.svg");
}
.openProject{
  content: url("../static/icons/iconOpenProject.svg");
}
.bd{
  content: url("../static/icons/iconBDLeftPanel.svg");
}
.result{
  content: url("../static/img/result.svg");
}
.climate{
  content: url("../static/icons/Clima.svg");
}
.crop{
  content: url("../static/icons/Cultivo.svg");
}
.floor{
  content: url("../static/icons/Suelo.svg");
}
.irrigation{
  content: url("../static/icons/Riego.svg");
}
.manure{
  content: url("../static/icons/Planes.svg");
}
.manure2{
  content: url("../static/icons/fertilizanteDark.png");
}
.results{
  max-height: 16px;
  content: url("../static/icons/Results.svg");
}
.contributionN{
  content: url("../static/icons/Planes.svg");
}
.recommendations {
  content: url("../static/icons/Planes.svg");
}
.content-list-menu{
  .item-title{
    color: #002035;
  }
  ul{
    li{
      &.accordion-item
        a{
          .item-inner{
            justify-content: flex-start!important;
            align-content: center;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            .item-title{
              color: #002035;
              padding-left: 0;
            }
            &::after{
              height: 0;
            }
        }
      }
      border-bottom: 0.5px solid var(--f7-list-item-border-color);

      &.accordion-item-opened{
        .item-content:not(:last-child){
          border-bottom: 1px solid var(--f7-list-item-border-color);
        }
      }
      &.panel-close{
        &.highlight {
          a{
            color: #0071BD !important;
            font-weight: 600;
          }
        }
        .item-content:not(:last-child){
          .item-inner{
            &::after{
              height: 0;
            }
          }
        }
      }
    }
  }
}

li.accordion-item.accordion-item-opened {
  background: #F4F5F7;
}

.toolbar_panel {
  bottom: 0px !important;
  padding: 5px 10px;
}
.chip-label {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;}
.list ul ul{
  padding-left: 0px;
}
.item-content{
  cursor: pointer;
}
.content-menu-header {
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 64px;
}
.content-menu .list ul {
  background: white;

}
.content-menu .list-group-title {
}
.content-menu .page-content {
  background: white;
}
//TODO: Ver porqué se ha alinea a la derecha | Alinear nombre del menú a la izquierda
.content-menu .list .item-inner{
  justify-content: flex-start;
  align-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.item-media {
  margin-left: 0 !important;
  min-width: 24px!important;
}

.icon-menu {
  width: 24px;
  height:24px;
  padding-right: 1rem;
}

.icon-home {
  background-image: url('../static/img/icon_inicio.svg');
}

.icon-taks {
  background-image: url('../static/img/ic_setting.svg');
}

.icon-logout {
  background-image: url('../static/img/ic_exitout.svg');
}
div.item-inner a {
  color: #003D3E !important;
}
.menu-header-item {
  display: flex;
  justify-content: center;
}
.image_logo{
  width: 85%;
  cursor: pointer;
}
.panel {
  min-width: 100px;
  max-width: 90vw;
}
.margin-left-icon {
  margin-left: 1rem;
}
</style>
